export default "__VITE_ASSET__B8kgxE6h__"